import { DeleteOutlined } from '@ant-design/icons';
import { getFileExtension } from '@helpers/document-info';
import type { Attachment } from '@interfaces/attachment';
import File from '@pages/components/File';
import buildClassName from '@utils/build-class-name';
import { Button } from 'antd';
import type { FC } from 'react';
import { useMemo } from 'react';

import styles from './AttachmentItem.module.scss';

interface OwnProps {
  attachment: Attachment;
  index: number;
  onDelete?: (index: number) => void;
}

const AttachmentItem: FC<OwnProps> = ({ attachment, index, onDelete }) => {
  const content = useMemo(() => {
    // TODO: content based on type with previews
    return (
      <>
        <File
          className={styles.file}
          name={attachment.filename}
          extension={getFileExtension(attachment.filename, attachment.mimeType)}
          previewData={attachment.previewBlobUrl}
          size={attachment.size}
          small
        />
        {onDelete && (
          <Button
            type="text"
            className={styles.deleteFile}
            icon={<DeleteOutlined />}
            title="Delete attachment"
            onClick={() => onDelete(index)}
          />
        )}
      </>
    );
  }, [attachment, index, onDelete]);

  return <div className={buildClassName(styles.root, styles.noGrouping)}>{content}</div>;
};

export default AttachmentItem;
